/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchSuppliers__SupplierFragment = { __typename: 'PimSupplier', id: string, title: string, linkedCrmCompany?: { __typename: 'CrmCompany', id: string } | null };

export type SupplierSelect__PimSearchSuppliersQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  isSubscribed: Types.Scalars['Boolean']['input'];
  pimSupplierIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sorting?: Types.InputMaybe<Array<Types.PimSearchSuppliersSorting>>;
}>;


export type SupplierSelect__PimSearchSuppliersQuery = { pimSearchSuppliers: { __typename: 'PimSearchSuppliersResult', totalCount: number, suppliers: Array<{ __typename: 'PimSupplier', id: string, title: string, linkedCrmCompany?: { __typename: 'CrmCompany', id: string } | null }> } };

export const SearchSuppliers__SupplierFragmentDoc = gql`
    fragment SearchSuppliers__Supplier on PimSupplier {
  id
  title
  linkedCrmCompany {
    id
  }
}
    `;
export const SupplierSelect__PimSearchSuppliersDocument = gql`
    query SupplierSelect__PimSearchSuppliers($limit: Int!, $isSubscribed: Boolean!, $pimSupplierIds: [ID!], $search: String, $sorting: [PimSearchSuppliersSorting!]) {
  pimSearchSuppliers(
    limit: $limit
    sorting: $sorting
    filters: {isSubscribed: $isSubscribed, pimSupplierIds: $pimSupplierIds}
    search: $search
  ) {
    suppliers {
      ...SearchSuppliers__Supplier
    }
    totalCount
  }
}
    ${SearchSuppliers__SupplierFragmentDoc}`;

/**
 * __useSupplierSelect__PimSearchSuppliersQuery__
 *
 * To run a query within a React component, call `useSupplierSelect__PimSearchSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierSelect__PimSearchSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierSelect__PimSearchSuppliersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      isSubscribed: // value for 'isSubscribed'
 *      pimSupplierIds: // value for 'pimSupplierIds'
 *      search: // value for 'search'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useSupplierSelect__PimSearchSuppliersQuery(baseOptions: Apollo.QueryHookOptions<SupplierSelect__PimSearchSuppliersQuery, SupplierSelect__PimSearchSuppliersQueryVariables> & ({ variables: SupplierSelect__PimSearchSuppliersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierSelect__PimSearchSuppliersQuery, SupplierSelect__PimSearchSuppliersQueryVariables>(SupplierSelect__PimSearchSuppliersDocument, options);
      }
export function useSupplierSelect__PimSearchSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierSelect__PimSearchSuppliersQuery, SupplierSelect__PimSearchSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierSelect__PimSearchSuppliersQuery, SupplierSelect__PimSearchSuppliersQueryVariables>(SupplierSelect__PimSearchSuppliersDocument, options);
        }
export function useSupplierSelect__PimSearchSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierSelect__PimSearchSuppliersQuery, SupplierSelect__PimSearchSuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplierSelect__PimSearchSuppliersQuery, SupplierSelect__PimSearchSuppliersQueryVariables>(SupplierSelect__PimSearchSuppliersDocument, options);
        }
export type SupplierSelect__PimSearchSuppliersQueryHookResult = ReturnType<typeof useSupplierSelect__PimSearchSuppliersQuery>;
export type SupplierSelect__PimSearchSuppliersLazyQueryHookResult = ReturnType<typeof useSupplierSelect__PimSearchSuppliersLazyQuery>;
export type SupplierSelect__PimSearchSuppliersSuspenseQueryHookResult = ReturnType<typeof useSupplierSelect__PimSearchSuppliersSuspenseQuery>;
export type SupplierSelect__PimSearchSuppliersQueryResult = Apollo.QueryResult<SupplierSelect__PimSearchSuppliersQuery, SupplierSelect__PimSearchSuppliersQueryVariables>;